import React from "react";
import {H3} from "BaseComponents/Text";
import {ServicePackagesWrapper, ServicePackagesInnerWrapper, ServiceItemsWrapper} from "./ServicePackages.styles"
import {getButtonColor} from "Helpers/ColorHelper";
import {ServicePackageCard} from './components/ServicePackageCard';

export const ServicePackages = ({Alias, BackgroundColor, Title, Items, ...rest}) => {
    const {color, textColor} = getButtonColor(BackgroundColor);
    
    return (<ServicePackagesWrapper className={`lg:pt-12 pt-6 lg:pb-20 pb-10 lg:px-12 px-4 ${Alias}`} bgColor={color}>
            <ServicePackagesInnerWrapper className={'container mx-auto'}>
                <H3
                    inline
                    margin="0"
                    marginsmall="0"
                    fontWeight="600"
                    color={textColor}
                >
                    {Title}
                </H3>
                <ServiceItemsWrapper>
                    {Items.map((c, index) => {
                        return <ServicePackageCard {...c} {...rest} key={index}/>
                    })}
                </ServiceItemsWrapper>
            </ServicePackagesInnerWrapper>
        </ServicePackagesWrapper>
    )
};
